<template>
  <div :id="id" :class="className" :style="{height:height,width:width}"/>
</template>

<script>
  import echarts from 'echarts'
  import 'echarts/map/js/china.js' // 引入中国地图数据

  export default {
    name: 'line-charts',
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      id: {
        type: String,
        default: 'chart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '235px'
      },
      chartData: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        chart: null
      }
    },
    computed:{
      isCollapsed(){
        return this.$store.state.app.sidebar.clapse
      }
    },
    watch:{
      isCollapsed(){
        this.resizeCharts()
      },
      "chartData":{
        handler(val){
          this.initLineCharts(val)
        },
        deep:true
      }
    },
    mounted() {
      this.initLineCharts()
      this.resizeCharts()
      window.addEventListener('resize', () => {
        this.resizeCharts()
      })
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      window.removeEventListener('resize', () => {
        this.resizeCharts()
      })
      this.chart.dispose() // 销毁
      this.chart = null
    },
    methods: {
      /**
       * 重置图表
       * */
      resizeCharts(){
        setTimeout( () => {
          if(this.chart){
            this.chart.resize()
          }

        }, 350)
      },
      /**
       * 初始化图表
       */
      initLineCharts(mapData) {
        this.chart = echarts.init(document.getElementById(this.id))
        console.log(this.chartData)
		if(!this.chartData.length){
			return false
		}
		let visitorNumArr = []
		let maxNum = 99
		this.chartData.map((item,index) => {
			visitorNumArr.push(item.value)
		})
		maxNum = Math.max.apply(null,visitorNumArr).toString()
		maxNum = (Math.pow(10,maxNum.length-1))*(Number(maxNum.substring(0,1))+1)
        this.chart.setOption({
          tooltip: {
            trigger: 'item',
          },
          legend: {
            show: false
          },
          visualMap:{
            type: 'continuous',
            min: 0,
            max: maxNum,
            text:['High','Low'],
            realtime: false,
            calculable : false,
            color: ['#3585e6','#b8ddf8']
          },
          series: [
            {
              type: 'scatter',
              coordinateSystem: 'geo' // 对应上方配置
            },
            {
              type: 'map',
              mapType: 'china',
              name: '访客区域', // 浮动框的标题
              geoIndex: 0,
              roam: false,
              label: {
                normal: {
                  show: false  //省份名称
                },
                emphasis: {
                  show: false
                }
              },
              scaleLimit:{
                min: 1,
                max: 1
              },
              data: mapData || []
            }
          ]
        })
      }
    },
  }
</script>

<style lang="">

</style>
